import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDrawerStore = defineStore('drawer', () => {
  // open/close states
  const isMobileDrawerOpen = ref(false);
  const isProjectsDrawerOpen = ref<boolean>(true);
  const isHelpDrawerOpen = ref(false);

  // navigation
  const visitedConversationsTabRouteName = ref<string>('');

  // alphabetized list
  return {
    isHelpDrawerOpen,
    isMobileDrawerOpen,
    isProjectsDrawerOpen,
    visitedConversationsTabRouteName,
  };
});
